import moment from "moment-timezone";

export const getDate = (date: any, isUTC = false) => {
    // Function is assuming that the date being passed in is a UTC Timezone date. Be aware
    if (isUTC) {
        const utcDate = moment.utc(date); // use moment to convert the date to UTC
        return moment.tz(utcDate, moment.tz.guess()); // convert the UTC date to the user's local timezone
    } else {
        return moment(date).tz(moment.tz.guess()); // get the time for your current timezone
    }
};

export const formatDate = (date: any, time: any, isUTC = false) => {
    date = moment(date, "MM/DD/YYYY").format("YYYY-MM-DD");
    return (date = date + "T" + time);
};
